export var SET_DYNAMIC_FAQ = 'SET_DYNAMIC_FAQ';
export var SET_SELECTED_POSITION = 'SET_SELECTED_POSITION';